module.exports = __webpack_public_path__ + "img/54.0056ae16.png";